import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    content: {
      flex: 1,
      marginHorizontal: 24,
      marginTop: 24,
      alignItems: 'center',
    },
    headerView: {
      marginTop: 30,
      marginHorizontal: 24,
    },
    glucoseInputContainer: {
      alignSelf: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 40,
      marginBottom: 16,
    },
    glucoseInputWrapper: {
      width: 150,
    },
    glucoseInput: {
      fontSize: 48,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    glucoseUnit: {
      marginTop: 8,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginHorizontal: 24,
    },
    leftButton: {
      flex: 1,
      marginRight: 8,
    },
    button: {
      flex: 1,
    },
    buttonLeft: {
      flexGrow: 1,
      flexShrink: 0,
      minWidth: 140,
      borderColor: colors.borderMuted,
    },
    buttonRight: {
      flexGrow: 1,
      flexShrink: 0,
      minWidth: 140,
      borderColor: colors.borderMuted,
    },
    marginHorizontal16: {
      marginHorizontal: 16,
    },
    dateTimeContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: 16,
      gap: 12,
    },
    dateTime: {
      marginTop: 30,
      alignSelf: 'flex-start',
      width: '100%',
    },
    underlineText: {
      textDecorationLine: 'underline',
    },
    fullWidth: {
      width: '100%',
    },
    ml16: {
      marginLeft: 16,
    },
    mt24: {
      marginTop: 24,
    },
    keyboardAccessory: {
      backgroundColor: colors.backgroundMuted,
      borderTopWidth: 1,
      borderTopColor: colors.borderMuted,
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    doneButton: {
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
  });

export default makeStyles;
